import styled from 'styled-components/macro';
import { device } from '../../../../../styles/device';
import { LayoutColumnContainer } from '../../../../shared/layout/layoutColumn/LayoutColumn.styles';
import { Button } from '../../../../shared/button';
import { Card } from '../../../../shared/card';

export const EndCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.layout.overScroll};
`;

export const Table = styled.section`
  margin-top: 30px;
`;

export const Col = styled.li`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 5px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.default.default};

  &:first-child {
    justify-content: flex-start;
    margin-left: 15px;
    padding-left: 0;
  }

  @media ${device.laptop} {
    &:first-child {
      border: 0;
      margin: 0;
    }
    &:nth-child(2) {
      justify-content: flex-start;
      padding-left: 0;
    }
  }
`;

export const Row = styled.ul`
  min-height: 55px;
  display: grid;
  grid-template-columns: auto 160px 50px;

  &:first-child {
    background-color: ${({ theme }) => theme.colors.background};
    min-height: 40px;
    ${Col} {
      border: 0;
    }
  }
  &:last-child {
    ${Col} {
      border: 0;
    }
  }

  ${LayoutColumnContainer} {
    padding: 0;
    grid-template-columns: 70px;
    grid-gap: 10px;

    .last {
      text-align: right;
    }
  }

  @media ${device.mobileM} {
    grid-template-columns: auto 70px 160px 50px;
  }
  @media ${device.mobileL} {
    grid-template-columns: auto 105px 160px 50px;
  }
  @media ${device.tablet} {
    grid-template-columns: auto 145px 105px 160px 50px;
  }
  @media ${device.laptop} {
    grid-template-columns: 70px auto 145px 115px 170px 50px;
  }
`;

export const HeaderRow = styled.ul`
  min-height: 40px;
  background-color: ${({ theme }) => theme.colors.background};
  display: grid;
  grid-template-columns: auto 210px;
  padding-right: 15px;

  &:first-child {
    ${Col} {
      border: 0;
      &:last-child {
        padding-right: 15px;
      }
    }
  }

  ${LayoutColumnContainer} {
    padding: 0;
    grid-template-columns: auto 105px;
    grid-gap: 0px;

    &:last-child {
      text-align: right;
    }
  }

  @media ${device.mobileM} {
    grid-template-columns: auto 210px;
    &:first-child {
      ${Col} {
        &:first-child {
          margin-left: 50px;
        }
      }
    }
  }
  @media ${device.mobileL} {
    &:first-child {
      ${Col} {
        &:first-child {
          margin-left: 70px;
        }
      }
    }
  }
`;

export const Icon = styled.div`
  height: 50px;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    svg {
      fill: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const CTAButton = styled(Button)`
  min-width: 170px;
`;
